import React from 'react';
import { Box, Text, Button, Flex, styled } from '@goodrx/matisse';

import { HmaConsentModal } from 'app/components/legal';
import { useToggledState } from 'app/hooks';

const StyledContainer = styled(Flex)`
  border: 1px solid ${(p) => p.theme.colors.greyLight};
  border-radius: ${(p) => p.theme.radius}px;
`;

export const GetCoupon: React.FC<{ mt?: number }> = (props) => {
  const [isModalOpen, toggleModalOpen] = useToggledState(false);

  return (
    <>
      <StyledContainer p={3} flexDirection={{ _: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} {...props}>
        <Box display="flex" flex={2} alignItems="center" justifyContent="space-between">
          <img src="/images/illustrations/coupon-bottle.png" alt="Bottle Pills Bag" width="80px" height="80px" />

          <Text ml={3} fontWeight={500}>
            Find GoodRx prescription savings for your prescriptions on HeyDoctor.
          </Text>
        </Box>

        <Box flex={1} alignItems="center" justifyContent="center">
          <Button variant="secondary" mt={{ _: 3, sm: 0 }} onClick={toggleModalOpen} block style={{ width: '100%' }}>
            Get Free Coupons and Prices
          </Button>
        </Box>
      </StyledContainer>

      <HmaConsentModal isOpen={isModalOpen} onClose={toggleModalOpen} attributionSource="Consent Modal - Get Coupons" />
    </>
  );
};
